import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import authService from '../services/authService';

const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // 'loading' | 'success' | 'error'
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('Enlace de verificación inválido.');
      return;
    }

    authService.verifyEmail(token)
      .then(() => {
        setStatus('success');
      })
      .catch((err) => {
        setStatus('error');
        setMessage(err.message || 'El enlace es inválido o ha expirado.');
      });
  }, [searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-df-surface2 px-4">
      <div className="max-w-md w-full bg-df-surface border border-df-border rounded-lg shadow-md p-8 text-center">

        {status === 'loading' && (
          <>
            <div className="w-12 h-12 border-4 border-df-accent border-t-transparent rounded-full animate-spin mx-auto mb-4" />
            <p className="text-df-muted">Verificando tu correo...</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="w-16 h-16 bg-df-success/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-df-success" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h1 className="text-2xl font-bold text-df-text mb-2">¡Correo verificado!</h1>
            <p className="text-df-muted mb-6">Tu cuenta está activa. Ya puedes iniciar sesión.</p>
            <button
              onClick={() => navigate('/')}
              className="w-full py-2 px-4 bg-df-accent-strong hover:bg-df-accent-deep text-white font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-df-accent focus:ring-offset-2"
            >
              Ir a iniciar sesión
            </button>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="w-16 h-16 bg-df-danger/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-df-danger" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <h1 className="text-2xl font-bold text-df-text mb-2">Enlace inválido</h1>
            <p className="text-df-muted mb-6">{message}</p>
            <button
              onClick={() => navigate('/')}
              className="w-full py-2 px-4 bg-gray-600 hover:bg-gray-700 text-white font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
            >
              Volver al inicio
            </button>
          </>
        )}

      </div>
    </div>
  );
};

export default VerifyEmailPage;
